"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLOATING_ALERT_DEFAULT_TIMEOUT = void 0;
var FLOATING_ALERT_DEFAULT_TIMEOUT = 4000;
exports.FLOATING_ALERT_DEFAULT_TIMEOUT = FLOATING_ALERT_DEFAULT_TIMEOUT;